import { SigningPinConstants } from 'src/redux/actions/constant';

//  status holds the backend SigningPinStatusResponse { hasPin, toggleOn }.
const initialState: any = {
  status: null,
  statusLoading: false,
  //  THIN-7788: terminal flag for a failed status fetch. Without it the hook re-dispatches
  //  the request on every render while status is null, so a failing /signing-pin/status
  //  (5xx / network) turns into an unbounded request loop.
  statusError: false,
  setupLoading: false,
  setupSuccess: false,
  setupError: null,
  resetLoading: false,
  resetSuccess: false,
  resetError: null,
};

export const signingPinReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SigningPinConstants.GET_SIGNING_PIN_STATUS_LOADING:
      //  Clear the error on a (re)try so an explicit re-request can recover.
      return { ...state, statusLoading: true, statusError: false };
    case SigningPinConstants.GET_SIGNING_PIN_STATUS_SUCCESS:
      return {
        ...state,
        statusLoading: false,
        statusError: false,
        status: action.payload?.data ?? action.payload,
      };
    case SigningPinConstants.GET_SIGNING_PIN_STATUS_FAILURE:
      //  Terminal: leave status null but mark the error so the hook stops re-fetching.
      return { ...state, statusLoading: false, statusError: true };

    case SigningPinConstants.SETUP_SIGNING_PIN_LOADING:
      return { ...state, setupLoading: true, setupError: null, setupSuccess: false };
    case SigningPinConstants.SETUP_SIGNING_PIN_SUCCESS:
      return { ...state, setupLoading: false, setupSuccess: true };
    case SigningPinConstants.SETUP_SIGNING_PIN_FAILURE:
      return { ...state, setupLoading: false, setupError: action.payload };

    case SigningPinConstants.RESET_SIGNING_PIN_LOADING:
      return { ...state, resetLoading: true, resetError: null, resetSuccess: false };
    case SigningPinConstants.RESET_SIGNING_PIN_SUCCESS:
      return { ...state, resetLoading: false, resetSuccess: true };
    case SigningPinConstants.RESET_SIGNING_PIN_FAILURE:
      return { ...state, resetLoading: false, resetError: action.payload };

    case SigningPinConstants.SIGNING_PIN_ACTION_RESET:
      return {
        ...state,
        setupError: null,
        setupSuccess: false,
        resetError: null,
        resetSuccess: false,
      };

    default:
      return state;
  }
};
